import { Unit } from "../domain/unit.js";

export function formatCombat(unit: Unit) {
  const melee = `${unit.meleeCombat}+`;

  // A ranged combat value of 0 means the unit cannot shoot at all.
  const ranged = unit.rangedCombat === 0 ? "none" : `${unit.rangedCombat}+`;

  // Most units hit just as well up close as at range, in which case there is
  // no point in cluttering the table with two identical values.
  return melee === ranged ? melee : `${melee}/${ranged}`;
}
